<div class="row m-0 p-0" *ngIf="vehiculoForm && !isLoadingGestion">

    <div class="fondo-gris"
        *ngIf="showModalGeneric || showModalVendors || showModalPhone || showModalVehicle || showModalOrders"> </div>

    <app-generic-modal *ngIf="showModalGeneric" [title]="generic_title" [message]="generic_message"
        [textButtonOk]="generic_textButtonOk" [textButtonCancel]="generic_textButtonCancel" [aspa]="generic_aspa"
        [isButtonOk]="generic_isButtonOk" [isButtonCancel]="generic_isButtonCancel"
        (modalClose)="closeModalGeneric($event)" [popupName]="generic_popupName">
    </app-generic-modal>

    <app-modal-phone *ngIf="showModalPhone" [isModal]="true" [CustomerCodePhone]="CustomerCodePhone"
        [TelephonePortable]="TelephonePortable" (childModalClose)="closeModalPhone($event)">
    </app-modal-phone>

    <dms-vehicle-select *ngIf="showModalVehicle" (modalCloseVehicle)="closeModalVehicle($event)">
    </dms-vehicle-select>


    <app-modal-orders *ngIf="showModalOrders" [ordenesAbiCurCerr]="ordenesAbiCurCerr" [pantalla]="'gestionForm'"
        (childModalClose)="closeModalOrder($event)">
    </app-modal-orders>


    <dms-vendors-modal *ngIf="showModalVendors" [pantalla]="'gestionForm'"
        (childVendorClose)="closeModalVendors($event)">
    </dms-vendors-modal>



    <div class=" m-0 p-0"
        [ngClass]="{
                    'col-xl-9 col-lg-9 col-md-9 col-sm-9': !gestionTerceros && !gestionOr && !recepcionVehiculo && !recepcionVO && !presupuestosTaller,
                    'col-xl-12 col-12': gestionTerceros || gestionOr || recepcionVehiculo || recepcionVO || presupuestosTaller}">
        <div class="p-0">


            <section class="formBox">
                <form [formGroup]="vehiculoForm" autocomplete="off">

                    <div class="formInit">
                        <!-- DATOS SUPERIOres -->
                        <div class="row">
                            <div class="col-5 mt-2">
                                <div class="row">
                                    <div class="form-group col-12" [ngClass]="{
                                                         'popoverClassic_blue_fine': !matriculaOk,
                                                         'popoverClassic_red_fine': matriculaDuplicate }">
                                        <label class="text-left pix_60 mt-1">{{'labels.matricula' | translate }}:</label>

                                        <input dmsInputRestrict popoverPlacement="right" [popoverOnHover]="true"
                                            autocomplete="off" [popover]="myPopover1" data-type="text" type="text"
                                            class="form-control anchurax60 float-right" formControlName="PlateNumber"
                                            maxlength="10" (blur)="blurElement('PlateNumber')" [ngClass]="{
                                                        'form-error':getValueControl('PlateNumber') || matriculaDuplicate,
                                                        'form-no-valid': !matriculaOk}"
                                            placeholder="{{ placeholderPlateNumber }}" appFocus>
                                        <dms-servibox-icon class="btn-icon" [value]="getVinForServiboxIcon()">
                                        </dms-servibox-icon>
                                        <popover-content #myPopover1>
                                            <div class="body-tooltip" *ngIf="!matriculaOk">
                                                <span
                                                    [innerHtml]="'errors.required.letrasynumerosMatricula' | translate | returnHtml: 'html'"></span>
                                            </div>
                                            <div class="body-tooltip " *ngIf="matriculaDuplicate">
                                                <span
                                                    [innerHtml]="'errors.required.matricualExiste' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12" [ngClass]="{
                                                        'popoverClassic_blue_fine': !VinOk,
                                                        'popoverClassic_red_fine':VinDuplicate   }">
                                        <label class="text-left pix_60 mt-1">{{ 'labels.vin' | translate }}
                                            :</label>

                                        <input dmsInputRestrict type="text" class="form-control anchurax60 float-right"
                                            autocomplete="off" popoverPlacement="right" [popoverOnHover]="true"
                                            [popover]="myPopover2" minlength="17" maxlength="17" formControlName="Vin"
                                            placeholder="{{ placeholderVin }}" (blur)="blurElement('Vin')" [ngClass]="{
                                                        'form-error':getValueControl('Vin') || VinDuplicate,
                                                        'form-no-valid': !VinOk  }">
                                        <i (click)="copyToClipboard()" class="fa fa-clipboard" appCurrentColor
                                            aria-hidden="true"></i>
                                        <img *ngIf="hasESA" class="iconBtn" (click)="showModalESA = true;"
                                            src="./assets/img/ESA_Icon.png">
                                        <popover-content #myPopover2>
                                            <div class="body-tooltip" *ngIf="!VinOk">
                                                <span
                                                    [innerHtml]="'errors.required.letrasynumeros' | translate | returnHtml: 'html'"></span>
                                            </div>
                                            <div class="body-tooltip " *ngIf="VinDuplicate">
                                                <span
                                                    [innerHtml]="'errors.required.vinExiste' | translate | returnHtml: 'html'"></span>
                                            </div>
                                        </popover-content>

                                    </div>
                                </div>

                                <div class="row">
                                    <div class="form-group col-12">
                                        <label class="text-left pix_60 mt-1">{{ 'labels.marca' |
                                            translate }}
                                            :</label>

                                        <select class="form-control  anchurax60 float-right" formControlName="BrandCode"
                                            (change)="changeBrand($event)">
                                            <option *ngFor="let item of GetAllVehicles" [value]="item.BrandCode">
                                                {{ item.Description }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="col-2">

                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label>{{'gestion_vehiculos.formLabel.engine' | translate}}</label>

                                            <kendo-dropdownlist formControlName="EnginePower" [data]="vehicleEngine"
                                                [textField]="'Description'" [valueField]="'Code'" [valuePrimitive]="true"
                                                (valueChange)="valueEngine($event)"
                                                class="form-control float-right altura1_5">
                                                <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                    <span class="kendo_list_template">{{ dataItem.Description }}</span>
                                                </ng-template>
                                            </kendo-dropdownlist>

                                        </div>

                                    </div>
                                </div>


                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-check ">
                                            <p class="reset mb-2">
                                                <input type="radio" id="test1" name="Type" formControlName="Type"
                                                    value="T" checked />
                                                <label for="test1">{{'gestion_vehiculos.formLabel.tourism' |
                                                    translate}}</label>
                                            </p>
                                        </div>
                                        <div class="form-check">
                                            <p class="reset">
                                                <input type="radio" id="test2" name="Type" formControlName="Type"
                                                    value="I" checked />
                                                <label for="test2">{{'gestion_vehiculos.formLabel.commercial' |
                                                    translate}}</label>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="col-5">
                                <div class="infoClient" [ngClass]="{'only_reading':formMode}">

                                    <ul *ngIf="gestionTerceros || gestionOr || recepcionVehiculo || presupuestosTaller">
                                        <li><strong>{{ 'labels.name_razon' | translate }}:</strong>
                                            {{ custumerData?.CustomerName }}</li>
                                        <li><strong>{{ 'labels.codigo_cliente' | translate }}:</strong>
                                            {{ custumerData?.CustomerCode }}</li>
                                        <li><strong>{{ 'labels.codigo_fiscal' | translate }}:</strong>
                                            {{ custumerData?.FiscalCode}}</li>
                                        <li>
                                            <p class="reset">
                                                <span class="text-bold">
                                                    {{ 'labels.telephone' | translate }}: </span>
                                                <span (click)="openModalPhone()" *ngIf="custumerData?.TelephonePortable"
                                                    class="color_blue text-bold cursor">
                                                    <i class="fa fa-mobile fa-lg color_blue mr-1"
                                                        aria-hidden="true"></i>
                                                    {{ custumerData?.TelephonePortable }}
                                                </span>

                                                <span *ngIf="custumerData?.TelephoneHome">
                                                    <i class="fa fa-phone  mr-1" aria-hidden="true"></i>
                                                    {{custumerData?.TelephoneHome}}</span>
                                            </p>
                                        </li>

                                    </ul>


                                    <ul *ngIf="gestionVehiculos || gestionVehiculosCortesia ">
                                        <li>
                                            <div class="row reset">
                                                <div class="col-6 reset">
                                                    <p class="reset text-not-over">
                                                        <strong>{{ 'labels.name_razon' | translate }}:</strong>
                                                    </p>
                                                </div>
                                                <div class="col-6 reset">
                                                    <p class="reset text-not-over"> {{ CustomerName }}</p>
                                                </div>
                                            </div>

                                        </li>
                                        <li><strong>{{ 'labels.codigo_cliente' | translate }}:</strong>
                                            {{CustomerCode }}</li>
                                        <li><strong>{{ 'labels.codigo_fiscal' | translate }}:</strong>
                                            {{ FiscalCode}}</li>

                                        <li>
                                            <p class="reset">
                                                <span class="text-bold">
                                                    {{ 'labels.telephone' | translate }}: </span>
                                                <span (click)="openModalPhone()" *ngIf="TelephonePortable"
                                                    class="color_blue text-bold cursor">
                                                    <i class="fa fa-mobile fa-lg color_blue mr-1"
                                                        aria-hidden="true"></i>
                                                    {{ TelephonePortable }}
                                                </span>
                                                <span *ngIf="carData?.ThirdParty?.TelephoneHome">
                                                    <i class="fa fa-phone  mr-1" aria-hidden="true"></i>
                                                    {{TelephoneHome}}</span>
                                            </p>
                                        </li>
                                    </ul>


                                    <ul *ngIf="stockVO || recepcionVO">
                                        <li><strong>{{'stock_vo.typeVehicle' | translate}}: </strong>{{ internalUse }}
                                        </li>
                                        <li><strong>{{'labels.ubicacion' | translate}}:
                                            </strong>{{ carData?.LocationDescription }}</li>
                                        <li><strong>{{'stock_vo.stockEntry' | translate}}:
                                            </strong>{{ registrationDate }}</li>
                                        <li><strong>{{'labels.estado' | translate}}: </strong>{{ vehicleState }}</li>
                                    </ul>

                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- NUEVO FALSO POPUP INCIO -->
                    <div class="fondo-gris" *ngIf="ShowDataVin"> </div>
                    <div class="popupVin" *ngIf="ShowDataVin">

                        <div class="container-header ">
                            <span>{{ 'gestion_vehiculos.popup.actualizarDatos' | translate}}</span>
                        </div>

                        <div class="container-section ">

                            <div class="row text-new-14">
                                <div class="col-11">
                                    <p><span>{{ 'gestion_vehiculos.popup.vinObligatorio' | translate }}</span></p>
                                </div>
                            </div>

                            <div class="row text-new-14">
                                <ul>
                                    <li>
                                        <span>{{ 'gestion_vehiculos.popup.vinCaracteres' | translate }}</span>
                                    </li>
                                    <li>
                                        <span>{{ 'gestion_vehiculos.popup.matriculaCaracteres' | translate }}</span>
                                    </li>
                                </ul>

                            </div>

                            <div class="row text-new-14">
                                <div class="col-8" [ngClass]="{
                                                        'popoverClassic_blue_fine': !matriculaOk,
                                                        'popoverClassic_red_fine': matriculaDuplicate }">
                                    <label class="mt-1 anchurax40 text-not-over">{{'labels.matricula' | translate
                                        }}:</label>

                                    <input dmsInputRestrict popoverPlacement="right" [popoverOnHover]="true"
                                        autocomplete="off" autocomplete="off" [popover]="myPopover1" data-type="text"
                                        type="text" class="form-control anchurax60 float-right"
                                        formControlName="PlateNumber" maxlength="10" (blur)="blurElement('PlateNumber')"
                                        [ngClass]="{
                                                        'form-error':getValueControl('PlateNumber') || matriculaDuplicate,
                                                        'form-no-valid': !matriculaOk}"
                                        placeholder="{{ placeholderPlateNumber }}">
                                    <popover-content #myPopover1>
                                        <div class="body-tooltip" *ngIf="!matriculaOk">
                                            <span
                                                [innerHtml]="'errors.required.letrasynumerosMatricula' | translate | returnHtml: 'html'"></span>
                                        </div>
                                        <div class="body-tooltip " *ngIf="matriculaDuplicate">
                                            <span
                                                [innerHtml]="'errors.required.matricualExiste' | translate | returnHtml: 'html'"></span>
                                        </div>
                                    </popover-content>
                                </div>
                            </div>

                            <div class="row text-new-14">
                                <div class="col-8" [ngClass]="{
                                                'popoverClassic_blue_fine': !VinOk,
                                                'popoverClassic_red_fine':VinDuplicate   }">
                                    <label class="mt-1 anchurax40 text-not-over">{{ 'labels.vin' | translate
                                        }}
                                        :</label>
                                    <!-- minlength="17"
                                         maxlength="17" -->
                                    <input dmsInputRestrict type="text" class="form-control anchurax60 float-right"
                                        popoverPlacement="right" [popoverOnHover]="true" [popover]="myPopover2"
                                        minlength="17" maxlength="17" formControlName="Vin"
                                        placeholder="{{ placeholderVin }}" (blur)="blurElement('Vin')" [ngClass]="{
                                                'form-error':getValueControl('Vin') || VinDuplicate,
                                                'form-no-valid': !VinOk  }">


                                    <popover-content #myPopover2>
                                        <div class="body-tooltip" *ngIf="!VinOk">
                                            <span
                                                [innerHtml]="'errors.required.letrasynumeros' | translate | returnHtml: 'html'"></span>
                                        </div>
                                        <div class="body-tooltip " *ngIf="VinDuplicate">
                                            <span
                                                [innerHtml]="'errors.required.vinExiste' | translate | returnHtml: 'html'"></span>
                                        </div>
                                    </popover-content>

                                </div>
                            </div>

                            <div class="modal-container-buttons row">
                                <div class="col-10">
                                    <button class="btn-steps mr-2" type="button" [disabled]="comprobarValidezVinPlate()"
                                        (click)="savePopupVin()">
                                        <span class="k-icon k-i-check-circle color_green text-size-big"></span>
                                        {{ 'labels.guardar' | translate}}
                                    </button>
                                    <button class="btn-steps" type="button" (click)="closePopupVin()">
                                        <span class="k-icon k-i-close-circle color_red text-size-big"></span>
                                        {{ 'labels.cancelar' | translate}}
                                    </button>
                                </div>
                            </div>


                            <div *ngIf="tipo === 'datosDuplicados' || VinDuplicate || matriculaDuplicate">

                                <div class="row text-new-14 justify-content-center">
                                    <div class="col-11">
                                        <p><span>{{ 'gestion_vehiculos.popup.registros' | translate }}</span></p>
                                    </div>
                                </div>

                                <div class="row justify-content-center text-new-14" *ngIf="matriculaDuplicate">
                                    <div class="col-8">
                                        <input formControlName="PlateNumber" type="text"
                                            class="text-bold color_blue input-duplicado">
                                    </div>
                                </div>

                                <div class="row justify-content-center text-new-14" *ngIf="VinDuplicate">
                                    <div class="col-8">
                                        <input formControlName="Vin" type="text"
                                            class="text-bold color_blue input-duplicado">
                                    </div>
                                </div>

                                <div class="row  modal-container-buttons">
                                    <div class="col-9">
                                        <button class="btn-steps mr-2" type="button" (click)="savePopupVin()">
                                            {{ 'botonContinuar' | translate}}
                                            <span class="k-icon k-i-arrow-end-right color_blue text-size-big"></span>
                                        </button>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <!-- NUEVO FALSO POPUP FIN -->


                    <!-- PESTAÑAS -->
                    <div class="col-12 p-0" [ngClass]="{
                                        'altura_pestanas_big':comprobarAltura(),
                                        'altura_pestanas_small':!comprobarAltura()
                                        }">
                        <kendo-tabstrip (tabSelect)="onTabSelect($event)">

                            <!--Pestaña  Vehículo -->
                            <kendo-tabstrip-tab class="Elemento" [disabled]="!showVehiculo" [title]="'labels.vehiculo' | translate"
                                [selected]="tab === 0">

                                <ng-template kendoTabContent>

                                    <div [ngClass]="{
                                                'contenedor_pestana_big':comprobarAltura(),
                                                'contenedor_pestana_small':!comprobarAltura()
                                                }" id="vehiculo">

                                        <div class="formInit_identificacion">
                                            <div class="row">
                                                <div class="col-1 ml-3 datos_identificacion mr-2 margin-top-08">
                                                    <span class="text-bold">
                                                        {{ "gestion_terceros.identificationData.source" |
                                                        translate}}:</span>
                                                </div>

                                                <div class="col-3 margin-top-08">
                                                    <!-- opacitysoft -->
                                                    <div
                                                        class="form-group_terceros datos_identificacion row only_reading">
                                                        <p class="mb-0 mr-1">
                                                            <input type="radio" id="test1" name="registrarionSource"
                                                                formControlName="registrarionSource" value="DMS"
                                                                checked />
                                                            <label for="test1" appCurrentColor>
                                                                {{ "gestion_vehiculos.formLabel.dms" |
                                                                translate}}</label>
                                                        </p>

                                                        <p class="mb-0 mr-1">
                                                            <input type="radio" id="test2" name="registrarionSource"
                                                                formControlName="registrarionSource"
                                                                value="CUSTOMERFIRST" />
                                                            <label for="test2" appCurrentColor>
                                                                {{"gestion_terceros.identificationData.c_first" |
                                                                translate}}</label>
                                                        </p>



                                                    </div>
                                                </div>

                                                <div class="col-6 margin-top-08">
                                                    <div class="form-group row only_reading">
                                                        <label class="anchurax40 col-form-label">
                                                            {{ 'gestion_terceros.identificationData.id_first' |
                                                            translate }}:</label>
                                                        <div class="anchurax55 pl-0">
                                                            <input type="text" class="form-control form-control-sm"
                                                                formControlName="sfVehicleId">
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="row m-2">

                                            <div class="col-12" *ngIf="stockVO && pais == 'fr'">
                                                <div class="form-group row">
                                                    <label class="col-sm-5 col-form-label">Livre de Police</label>
                                                    <div class="col-sm-7">
                                                        <input type="text" class="form-control form-control-sm"
                                                            name="livrepolice">
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-6 mt-2">
                                                <div class="form-group row altura1_5">
                                                    <label class="anchurax40 mt-1 col-form-label text-not-over">
                                                        {{ "gestion_vehiculos.formLabel.commercialBrand" | translate }}
                                                        :</label>

                                                    <input maxlength="16" formControlName="ModelCode" type="text"
                                                        class="form-control anchurax45  mr-1 " appFocus/>

                                                    <button type="button" [disabled]="formMode || !mostrarLupas || isModal"
                                                        (click)="openModalVehicle()"
                                                        class="btn btn-secondary float-right  btn-sm  altura1_5 search">
                                                        <i class="iconSearch k-icon k-i-search"></i>
                                                    </button>
                                                </div>

                                                <div class="form-group row">
                                                    <label class="anchurax40 col-form-label">{{
                                                        'gestion_vehiculos.formLabel.km' | translate }}</label>
                                                    <div class="anchurax55 pl-0">
                                                        <input type="text" class="form-control form-control-sm"
                                                            [ngClass]="{'form-error': getValueControl('KM') }"
                                                            maxlength="6" appDigitOnly formControlName="KM">
                                                    </div>
                                                </div>

                                                <div class="form-group row autocompleted_1">
                                                    <label *ngIf="filial !== 'AP'" class="anchurax40   col-form-label">{{
                                                        'labels.OPB_CODE' | translate }}</label>

                                                    <label *ngIf="filial === 'AP'" class="anchurax40   col-form-label">{{
                                                        'labels.modelo' | translate }}</label>



                                                    <p-autoComplete field="Description"
                                                        inputStyleClass="form-control inline" formControlName="Opb"
                                                        (onSelect)="setSelectedCode($event)" (click)="onInputClick()"
                                                        (completeMethod)="search($event)" [suggestions]="dataOpb"
                                                        class="anchurax40 " (blur)="isEmpty('Opb')"
                                                        [ngClass]="{'iconoInteriorSearch': isEmpty('Opb') }">
                                                        <ng-template let-value pTemplate="selectedItem">
                                                            {{value.OpbCode}} {{value.Description}}
                                                        </ng-template>
                                                    </p-autoComplete>


                                                    <div class="anchurax15 ml-1">
                                                        <input type="text" class="form-control form-control-sm"
                                                            formControlName="OpbCode">
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label for="" class="anchurax40 col-form-label">{{
                                                        'gestion_vehiculos.formLabel.numberOrganization' | translate
                                                        }}</label>

                                                    <div class="anchurax55 pl-0">
                                                        <input type="text" class="form-control form-control-sm"
                                                            maxlength="5" formControlName="OrganizationNumber">
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label class="anchurax40 col-form-label">{{
                                                        'labels.descripcion' | translate
                                                        }}</label>
                                                    <div class="anchurax55 pl-0">

                                                        <input type="text" maxlength="50"
                                                            placeholder="{{ placeholderDescripcion }}"
                                                            class="form-control form-control-sm"
                                                            [ngClass]="{'form-error': getValueControl('Description') }"
                                                            (blur)="blurElement('Description')"
                                                            formControlName="Description">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6 mt-2">
                                                <div class="form-group row">
                                                    <label class="anchurax40 text-not-over col-form-label">{{
                                                        'gestion_vehiculos.formLabel.ModelYear' | translate
                                                        }}:</label>
                                                    <div class="anchurax50  pl-0">
                                                        <input type="number" class="form-control form-control-sm"
                                                        formControlName="ModelYear"
                                                        (blur)="validateModelYear()"
                                                        autocomplete="off"
                                                        [ngClass]="{'form-error': getValueControl('ModelYear') || anioKO ,
                                                        'form-no-valid': anioKO}"

                                                        placeholder="{{ placeholderModelYear }}"
                                                        popoverPlacement="bottom" [popoverOnHover]="true" [popover]="myPopover1"
                                                        >
                                                        <popover-content #myPopover1>
                                                            <div class="body-tooltip" *ngIf="anioKO">
                                                                <span class="popupMYear">{{'messages.ModelYearKO' | translate}}</span>
                                                            </div>
                                                        </popover-content>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label class="anchurax40 text-not-over col-form-label">{{
                                                        'gestion_vehiculos.formLabel.modification' | translate
                                                        }}:</label>
                                                    <div class="anchurax50  pl-0">
                                                        <input type="text" class="form-control form-control-sm"
                                                            maxlength="50" formControlName="VehicleModification">
                                                    </div>
                                                </div>
                                                <div class="form-group row" *ngIf="stockVO && pais === 'fr'">
                                                    <label class="anchurax40 text-not-over col-form-label">Type de
                                                        KM:</label>
                                                    <div class="anchurax50 pl-0">
                                                        <input type="text" class="form-control form-control-sm"
                                                            name="typekm">
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        title="{{ 'gestion_vehiculos.formLabel.repairAmount' | translate }}"
                                                        class="anchurax40 text-not-over  mt-1 col-form-label">{{
                                                        'gestion_vehiculos.formLabel.repairAmount' | translate
                                                        }}:</label>
                                                    <div class="anchurax50  pl-0">
                                                        <kendo-numerictextbox maxlength="12" [min]="min" [max]="max"
                                                            [spinners]="false" formControlName="LastInvoiceAmount"
                                                            [format]="formatOptions" class="form-control">
                                                        </kendo-numerictextbox>

                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        title="{{ 'gestion_vehiculos.formLabel.datelastRepair' | translate }}"
                                                        class="anchurax35 text-not-over  mt-1 col-form-label">{{
                                                        'gestion_vehiculos.formLabel.datelastRepair' | translate
                                                        }}</label>

                                                    <div class="anchurax30  pl-0 ancho-especial"
                                                        [ngClass]="{ 'readonly': gestionTerceros  }">

                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'LastRepairDate'">
                                                        </calendario>
                                                    </div>

                                                    <div class="anchurax30  ml-1">
                                                        <input type="text" readonly class="form-control form-control-sm"
                                                            [value]="ordenStatus">
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label class="anchurax30 text-not-over   mt-1 col-form-label">{{
                                                        'gestion_vehiculos.formLabel.dateNextVisit' | translate
                                                        }}:</label>
                                                    <div class="anchurax65   pl-0">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'NextVisitDate'">
                                                        </calendario>

                                                    </div>
                                                </div>

                                                <div class="form-group row" *ngIf="stockVO || gestionVehiculosCortesia">
                                                    <div class="col-6"
                                                        [ngClass]=" {   'only_reading': statusFormSend ==='new' }">
                                                        <p class="m-0 float-left">
                                                            <input type="radio" id="vo" name="InternalVehicleUse"
                                                                formControlName="InternalVehicleUse" value="VO" />
                                                            <label for="vo">VO</label>
                                                        </p>
                                                        <p class="m-0 float-right">
                                                            <input type="radio" id="cortesia" name="InternalVehicleUse"
                                                                formControlName="InternalVehicleUse" value="VC" />
                                                            <label for="cortesia">Cortesía</label>
                                                        </p>
                                                    </div>
                                                    <span *ngIf="status === 'RE'"
                                                        [ngStyle]="{'color': '#d03030','font-weight':'bold'}">Vehículo
                                                        reservado
                                                    </span>
                                                </div>

                                            </div>

                                            <div class="col-12 ">
                                                <div class="form-group row">
                                                    <label class="anchurax20 col-form-label">{{
                                                        'labels.notas' | translate }}</label>
                                                    <div class="anchurax80 ">
                                                        <textarea class="form-control form-control-sm w-100 noResize "
                                                            formControlName="Comment" maxlength="200">
                                                            </textarea>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12  justify-content-center" *ngIf="siBaja">
                                                <div class="text-bold color_red">
                                                    <p class="m-0">
                                                        <span>{{ bajaVehiculo }}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 justify-content-center" *ngIf="carData.InternalVehicleUse === 'VO' && transmitter !== 'stockVO'">
                                            <div class="text-bold text-center color_red">
                                                <p class="m-0">
                                                    <span>{{'messages.datosVehiculoVO' | translate}}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!-- Pestaña  Propietario -->
                            <kendo-tabstrip-tab [disabled]="!showPropietario" [selected]="tab === 1"
                                [title]="'labels.propietario' | translate">
                                <ng-template kendoTabContent>

                                    <div [ngClass]=" {  'contenedor_pestana_big':comprobarAltura(),
                                                'contenedor_pestana_small':!comprobarAltura()   }" id="propietario">
                                        <div class="row">
                                            <div class="col-12">

                                                <!-- CAJA 1 -->
                                                <div class="ownerBox row" formGroupName="ThirdParty">
                                                    <h2 class="mb-2 pix_100" appCurrentColor [backgroundColor]="true">
                                                        {{'gestion_vehiculos.formLabel.titular' | translate}}</h2>

                                                    <div class="col-5">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.codigo_cliente' | translate}}"
                                                                class="col-sm-5 col-form-label mt-1 text-not-over">
                                                                {{'labels.codigo_cliente' |
                                                                translate}}</label>

                                                            <div class="col-sm-7">
                                                                <input type="text" appFocus class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customercode')"
                                                                    (keyup)="getInformationTypeClient(customercode.value)"
                                                                    formControlName="CustomerCode"
                                                                    maxlength="7"
                                                                    placeholder="{{ placeholderCustomerCode }}"
                                                                    [ngClass]="{'form-error': getValueControlThirdParty()}"
                                                                    #customercode>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div class="col-7">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.name_razon' | translate}}"
                                                                class="col-sm-4 col-form-label  mt-1 text-not-over">
                                                                {{'labels.name_razon' | translate}} </label>
                                                            <div class="col-sm-8">

                                                                <input type="text" class="form-control form-control-sm"
                                                                    placeholder="{{ placeholderCustomerName }}"
                                                                    [ngClass]="{'form-error': getValueControlThirdParty('ThirdParty')}"
                                                                    formControlName="CustomerName"
                                                                    (focus)="ownerChange('customername')"
                                                                    (keyup)="getInformationTypeClient(customername.value)"
                                                                    #customername>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- CAJA 2 -->
                                                <div class="ownerBox row" formGroupName="ThirdPartyDriverCode">
                                                    <h2 class="mb-2 pix_100" appCurrentColor [backgroundColor]="true">
                                                        {{'gestion_vehiculos.formLabel.driver' | translate}}</h2>
                                                    <div class="col-5">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.codigo_cliente' | translate}}"
                                                                class="col-sm-5 col-form-label  mt-1 text-not-over">
                                                                {{'labels.codigo_cliente' | translate}}
                                                            </label>
                                                            <div class="col-sm-7">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    placeholder="{{ placeholdercustomercodedriver }}"
                                                                    maxlength="7"
                                                                    [ngClass]="{'form-error': getValueControlThirdPartyDriverCode()}"
                                                                    (focus)="ownerChange('customercodedriver')"
                                                                    (keyup)="getInformationTypeClient(customercodedriver.value)"
                                                                    formControlName="CustomerCode" #customercodedriver>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-7">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.name_razon' | translate}}"
                                                                class="col-sm-4 col-form-label  mt-1 text-not-over">{{'labels.name_razon'
                                                                | translate}}
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customernamedriver')"
                                                                    placeholder="{{ placeholdercustomernamedriver }}"
                                                                    [ngClass]="{'form-error': getValueControlThirdPartyDriverCode()}"
                                                                    (keyup)="getInformationTypeClient(customernamedriver.value)"
                                                                    formControlName="CustomerName" #customernamedriver>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- CAJA 3 -->
                                                <div class="ownerBox row " formGroupName="ThirdPartyInvoiceCode">
                                                    <h2 class="mb-2 pix_100" appCurrentColor [backgroundColor]="true">
                                                        {{'gestion_vehiculos.formLabel.invoiceClient' | translate}}</h2>
                                                    <div class="col-5">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.codigo_cliente' | translate}}"
                                                                class="col-sm-5 col-form-label  mt-1 text-not-over">
                                                                {{'labels.codigo_cliente' |
                                                                translate}}</label>
                                                            <div class="col-sm-7">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customercodeinvoice')"
                                                                    (keyup)="getInformationTypeClient(customercodeinvoice.value)"
                                                                    maxlength="7"
                                                                    placeholder="{{ placeholdercustomercodeinvoice }}"
                                                                    [ngClass]="{'form-error': getValueControlThirdPartyInvoiceCode()}"
                                                                    formControlName="CustomerCode" #customercodeinvoice>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-7">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.name_razon' | translate}}"
                                                                class="col-sm-4 col-form-label  mt-1 text-not-over">
                                                                {{'labels.name_razon' | translate}} </label>
                                                            <div class="col-sm-8">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customernameinvoice')"
                                                                    (keyup)="getInformationTypeClient(customernameinvoice.value)"
                                                                    placeholder="{{ placeholdercustomernameinvoice }}"
                                                                    [ngClass]="{'form-error': getValueControlThirdPartyInvoiceCode()}"
                                                                    formControlName="CustomerName" #customernameinvoice>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- CAJA 4 -->
                                                <div class="ownerBox row" formGroupName="CustomerPrescriber"
                                                    *ngIf="DDCEnabled">
                                                    <h2 class="mb-2 pix_100" appCurrentColor [backgroundColor]="true">
                                                        {{'gestion_vehiculos.formLabel.prescriber' | translate}}</h2>
                                                    <div class="col-5">
                                                        <div class="form-group row">
                                                            <label title=" {{'labels.codigo_cliente' | translate}}"
                                                                class="col-sm-5 col-form-label  mt-1 text-not-over">
                                                                {{'labels.codigo_cliente' |
                                                                translate}}</label>
                                                            <div class="col-sm-7">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customerCodePrescriberCode')"
                                                                    (keyup)="getInformationTypeClient(customerCodePrescriberCode.value)"
                                                                    formControlName="CustomerCode"
                                                                    #customerCodePrescriberCode>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-7">
                                                        <div class="form-group row">
                                                            <label title=" {{'labels.name_razon' | translate}}"
                                                                class="col-sm-4 col-form-label  mt-1 text-not-over ">
                                                                {{'labels.name_razon' | translate}} </label>
                                                            <div class="col-sm-8">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customerNamePrescriberCode')"
                                                                    (keyup)="getInformationTypeClient(customerNamePrescriberCode.value)"
                                                                    formControlName="CustomerName"
                                                                    #customerNamePrescriberCode>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- CAJA 5 -->
                                                <div class="ownerBox row" formGroupName="CustomerKeeper"
                                                    *ngIf="DDCEnabled">

                                                    <h2 class="mb-2 pix_100" appCurrentColor [backgroundColor]="true">
                                                        {{'gestion_vehiculos.formLabel.keeper' | translate}}</h2>
                                                    <div class="col-5">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.codigo_cliente' | translate}}"
                                                                class="col-sm-5 col-form-label  mt-1 text-not-over">{{'labels.codigo_cliente'
                                                                | translate}}</label>
                                                            <div class="col-sm-7">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customerKeeperCode')"
                                                                    (keyup)="getInformationTypeClient(customerKeeperCode.value)"
                                                                    formControlName="CustomerCode" #customerKeeperCode>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-7">
                                                        <div class="form-group row">
                                                            <label title="{{'labels.name_razon' | translate}}"
                                                                class="col-sm-4 col-form-label  mt-1 text-not-over">{{'labels.name_razon'
                                                                | translate}}
                                                            </label>
                                                            <div class="col-sm-8">
                                                                <input type="text" class="form-control form-control-sm"
                                                                    (focus)="ownerChange('customerKeeperName')"
                                                                    (keyup)="getInformationTypeClient(customerKeeperName.value)"
                                                                    formControlName="CustomerName" #customerKeeperName>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!--Pestaña  Garantia -->
                            <kendo-tabstrip-tab [disabled]="!showGarantia" [title]="'labels.garantia' | translate"
                                [selected]="tab === 2">
                                <ng-template kendoTabContent>

                                    <div [ngClass]="
                                                {
                                                'contenedor_pestana_big':comprobarAltura(),
                                                'contenedor_pestana_small':!comprobarAltura()
                                                }" class="pt-2">
                                        <div class="row m-1">

                                            <div class="col-12 ">
                                                <div class="form-group row">
                                                    <!-- readonly -->
                                                    <label title="{{'labels.vendedor' | translate}}"
                                                        class="col-sm-2 col-form-label text-not-over">
                                                        {{'labels.vendedor' | translate}}:</label>

                                                    <div class="col-sm-10">

                                                        <button (click)="openVendor()" [disabled]="isModal"
                                                            class="btn btn-secondary float-right  btn-sm altura1_5 search">
                                                            <i class="iconSearch k-icon k-i-search"></i>
                                                        </button>
                                                        <input type="text" autocomplete="off"
                                                            class="form-control form-control-sm anchurax90"
                                                            formControlName="VendorName" appFocus>
                                                    </div>


                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.startWarrantyVN' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'gestion_vehiculos.formLabel.startWarrantyVN'
                                                        | translate}}:
                                                    </label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'GuaranteeDate'">
                                                        </calendario>

                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.endWarrantyVO' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'gestion_vehiculos.formLabel.endWarrantyVN'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'EndBrandGuaranteeDate'">
                                                        </calendario>

                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.endWarrantyVO' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'gestion_vehiculos.formLabel.endWarrantyVO'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'EndVendorGuaranteeDate'">
                                                        </calendario>

                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.endExWarrantyVO' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'gestion_vehiculos.formLabel.endExWarrantyVO'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'EndPlusGuaranteeDate'">
                                                        </calendario>

                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.extendedWarranty' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">
                                                        {{ 'gestion_vehiculos.formLabel.extendedWarranty' | translate
                                                        }}:</label>
                                                    <div class="col-sm-8">
                                                        <kendo-dropdownlist formControlName="GuaranteeExtCode"
                                                            [defaultItem]="GuaranteeExtCode" [data]="codigosGarantia"
                                                            [textField]="'Description'" [valueField]="'GARANTEEEXTCODE'"
                                                            (valueChange)="valueGuarantee($event)"
                                                            [valuePrimitive]="true"
                                                            class="form-control float-right altura1_5">
                                                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                                                <span class="kendo_list_template">{{
                                                                    dataItem.Description }}</span>
                                                            </ng-template>
                                                        </kendo-dropdownlist>
                                                    </div>
                                                </div>
                                                <div *ngIf="pais === 'fr'" class="form-group row">
                                                    <label
                                                        title="{{'labels.tipo_garantia' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'labels.tipo_garantia'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control" formControlName="GuaranteeType">
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6">
                                                <div class="form-group row">
                                                    <label title="{{'labels.fecha_venta' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'labels.fecha_venta'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'SaleDate'">
                                                        </calendario>

                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label title="{{'labels.fecha_matriculacion' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'labels.fecha_matriculacion'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'MatriculationDate'">
                                                        </calendario>
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.dateLastMat' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'gestion_vehiculos.formLabel.dateLastMat'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'LastMatriculationDate'">
                                                        </calendario>

                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <label
                                                        title="{{'gestion_vehiculos.formLabel.dateNextITV' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'gestion_vehiculos.formLabel.dateNextITV'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <calendario [formulario]="vehiculoForm"
                                                            [controlName]="'VehicleInspectionDate'">
                                                        </calendario>

                                                    </div>
                                                </div>
                                                <div *ngIf="pais === 'fr'" class="form-group row">
                                                    <label
                                                        title="{{'labels.duracion_garantia' | translate}}"
                                                        class="col-sm-4 col-form-label text-not-over">{{'labels.duracion_garantia'
                                                        | translate}}:</label>
                                                    <div class="col-sm-8">
                                                        <input type="number" class="form-control" formControlName="GuaranteeDuration">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!--Pestaña  OR -->
                            <kendo-tabstrip-tab [disabled]="!showOR" [title]="'labels.or' | translate" [selected]="tab === 3">
                                <ng-template kendoTabContent>
                                    <div [ngClass]=" {'contenedor_pestana_big':comprobarAltura(),'contenedor_pestana_small':!comprobarAltura()}"
                                         class="row">
                                        <div class="col-12">
                                            <app-vehicles [cargarVista]='transmitter' [formMode]="formMode">
                                            </app-vehicles>
                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!--Pestaña  SEGURIDAD -->
                            <kendo-tabstrip-tab [disabled]="!showSeguridad" [selected]="tab === 4"
                                [title]="'labels.seguridad' | translate">
                                <ng-template kendoTabContent>

                                    <div [ngClass]="
                                                {
                                                'contenedor_pestana_big':comprobarAltura(),
                                                'contenedor_pestana_small':!comprobarAltura()
                                                }">
                                        <div class="row">
                                            <div class="col-6" *ngIf="!gestionOr">
                                                <div class="row">
                                                    <div class="col-12 ml-3">
                                                        <div class="form-group row">
                                                            <label class="col-sm-2 col-form-label">{{'labels.codigo'
                                                                | translate}}:
                                                            </label>
                                                            <div class="col-sm-10">
                                                                <input type="text" appFocus (focus)="getFocusAction()"
                                                                    class="form-control form-control-sm" [disabled]="isModal"
                                                                    [value]="segurityCode?.VEHICLECODE" name="codigo"
                                                                    #codigo>

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">


                                                        <button type="button" class="btn btn-secondary btn-sm mt-1"
                                                            (click)="actions('remove', inputCode, textACode)"
                                                            [disabled]="remove || isModal">
                                                            {{'labels.borrar'| translate}}<i class="fa fa-trash"></i>
                                                        </button>

                                                        <button type="button" class="btn btn-secondary btn-sm mt-1"
                                                            (click)="addRegister(inputCode, textACode)"
                                                            [disabled]="botonNuevo || isModal">
                                                            {{'labels.anadir'| translate}}<i class="fa fa-plus"></i>
                                                        </button>

                                                        <button type="button" class="btn btn-secondary btn-sm mt-1"
                                                            (click)="actions('edit', inputCode, textACode)"
                                                            [disabled]="edit || isModal">
                                                            {{'labels.editar'| translate}}<i class="fa fa-pencil"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-6" *ngIf="!gestionOr">
                                                <div class="form-group row pl-3">
                                                    <label class="col-sm-2 col-form-label">{{'labels.descripcion'
                                                        | translate}}:
                                                    </label>
                                                    <div class="col-sm-10">
                                                        <textarea name="codigoDescription" (focus)="getFocusAction()"
                                                            class="form-control form-control-sm noResize" [disabled]="isModal"
                                                            [value]="segurityCode?.Value" #codigoDescription>
                                                            </textarea>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 mt-1">
                                                <kendo-grid (cellClick)="selectRowSecurity($event)"
                                                    [data]="segurity[0].gridView" [height]="150">
                                                    <kendo-grid-column *ngFor="let item of segurity[0].th;let i=index"
                                                        data-num="i" field="{{segurity[0].fields[i]}}"
                                                        [width]="segurity[0].width[i]" title="{{item | translate}}">
                                                        <ng-template kendoGridHeaderTemplate let-column
                                                            let-columnIndex="columnIndex">
                                                            <span
                                                                title="{{item | translate}}">{{item | translate}}</span>
                                                        </ng-template>
                                                        <ng-template kendoGridCellTemplate let-dataItem>
                                                            <span
                                                                title="{{dataItem[segurity[0].fields[i]]}}">{{dataItem[segurity[0].fields[i]]}}</span>
                                                        </ng-template>
                                                    </kendo-grid-column>
                                                </kendo-grid>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!--Pestaña  GESTION  -->

                            <kendo-tabstrip-tab [disabled]="!showGestion" [selected]="tab === 5"
                                [title]="'labels.gestion' | translate">
                                <ng-template kendoTabContent>
                                    <div [ngClass]=" {
                                                    'contenedor_pestana_big':comprobarAltura() ,
                                                    'contenedor_pestana_small':!comprobarAltura()
                                                    }">

                                        <form [formGroup]="gestion" class="row">


                                            <div class="col-12">
                                                <button type="button" class="btn btn-secondary btn-sm  float-right"
                                                    [disabled]="desactivarGestExp" (click)="gestionarExpediente()">
                                                    <span class="k-icon  k-i-track-changes color_white mr-1"></span>
                                                    {{'stock_vo.manageFile' | translate}}
                                                </button>
                                            </div>
                                            <div class="css-table col-6 mt-2">
                                                <div class="css-table-body">
                                                    <div class="css-table-row form-group">
                                                        <div>{{'stock_vo.stateVehicle' | translate}}:</div>
                                                        <select class="form-control  " formControlName="vehiculoStatus"
                                                            (change)="changeState($event)">
                                                            <option *ngFor="let item of vehicleStates"
                                                                [value]="item.Value">
                                                                {{ item.Description }}
                                                            </option>
                                                        </select>


                                                    </div>
                                                    <div class="css-table-row form-group">
                                                        <div>{{'labels.ubicacion' | translate}}:</div>

                                                        <select class="form-control  mt-1" formControlName="ubicacion"
                                                            (change)="changeState($event)">
                                                            <option *ngFor="let item of ubicaciones"
                                                                [value]="item.VOLOCATIONCODE">
                                                                {{ item.Description }}
                                                            </option>
                                                        </select>

                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.Nstock' | translate}}:</div>
                                                        <div>
                                                        </div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.stockEntry' | translate}}:</div>
                                                        <div>{{ registrationDate }}</div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.outputStock' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="css-table col-6 mt-2">
                                                <div class="css-table-body">
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.setUpExpenses' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.purchasePrice' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.orAssociates' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.cost' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.adequacyExpenses' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.attachedFiles' | translate}}:</div>
                                                        <div>0</div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.salePrice' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                    <div class="css-table-row">
                                                        <div>{{'stock_vo.margin' | translate}}:</div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                            </div>

                                        </form>

                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!--Pestaña-->

                            <kendo-tabstrip-tab [disabled]="!showEstadoCarroceria || pais === 'fr' || pais === 'pt'"
                            [selected]="tab === 6" [title]="'labels.estado_carroceria' | translate">
                                <ng-template kendoTabContent>
                                    <div [ngClass]="
                                                    {
                                                    'contenedor_pestana_big':comprobarAltura() ,
                                                    'contenedor_pestana_small':!comprobarAltura()
                                                    }">


                                        <form [formGroup]="carroceria">

                                            <div class="contenedor-doble">
                                                <div class="rowreset">
                                                    <div class="col-12 pt-4 pb-1 pr-2 pl-2 contenedor-interior">

                                                        <h3 appCurrentColor [backgroundColor]="true" class="mb-2">
                                                            {{ 'labels.estado_carroceria' | translate }}
                                                            <i class="k-icon  k-i-edit k-i-pencil float-right cursor"
                                                                (click)="reset()"></i>
                                                        </h3>
                                                        <div class="row">
                                                            <div class="col-6">



                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.trasera' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">


                                                                        <kendo-dropdownlist [data]="comboCarroceria[0]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            (valueChange)="estadoPieza('trasera',$event)"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            [valuePrimitive]="true"
                                                                            appFocus
                                                                            formControlName="trasera">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.maletero' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[1]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="maletero"
                                                                            (valueChange)="estadoPieza('maletero',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">
                                                                        {{ 'gestion_vehiculos_vc.rtraseraIzq' |
                                                                        translate }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[2]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="rtraseraIzq"
                                                                            (valueChange)="estadoPieza('rtraseraIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">
                                                                        {{ 'gestion_vehiculos_vc.rTraseraDch' |
                                                                        translate }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[3]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="rTraseraDch"
                                                                            (valueChange)="estadoPieza('rTraseraDch',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.aletaTrasIzq' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[4]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="aletaTrasIzq"
                                                                            (valueChange)="estadoPieza('aletaTrasIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.aletaTrasDch' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[5]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="aletaTrasDch"
                                                                            (valueChange)="estadoPieza('aletaTrasDch',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.lunaTrasera' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[6]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="lunaTrasera"
                                                                            (valueChange)="estadoPieza('lunaTrasera',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.puertaTrasIzq' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[7]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="puertaTrasIzq"
                                                                            (valueChange)="estadoPieza('puertaTrasIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.puertatrasDer' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[8]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="puertatrasDer"
                                                                            (valueChange)="estadoPieza('puertatrasDer',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.faldonIzq' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[9]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="faldonIzq"
                                                                            (valueChange)="estadoPieza('faldonIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div class="col-6">

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.faldonDer' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[10]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="faldonDer"
                                                                            (valueChange)="estadoPieza('faldonDer',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.puertaDelIzq' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[11]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="puertaDelIzq"
                                                                            (valueChange)="estadoPieza('puertaDelIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.puertaDelDer' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[12]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="puertaDelDer"
                                                                            (valueChange)="estadoPieza('puertaDelDer',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.ruedaDelIzq' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[13]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="ruedaDelIzq"
                                                                            (valueChange)="estadoPieza('ruedaDelIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.ruedaDelDer' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[14]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="ruedaDelDer"
                                                                            (valueChange)="estadoPieza('ruedaDelDer',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.lunaDelantera' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[15]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="lunaDelantera"
                                                                            (valueChange)="estadoPieza('lunaDelantera',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.capo' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[16]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="capo"
                                                                            (valueChange)="estadoPieza('capo',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.frontal' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[17]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="frontal"
                                                                            (valueChange)="estadoPieza('frontal',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.aletaDelIzq' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[18]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="aletaDelIzq"
                                                                            (valueChange)="estadoPieza('aletaDelIzq',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                                <div class="row mt-1">
                                                                    <label
                                                                        class="col-4 mt-1 text-right col-form-label text-not-over">{{
                                                                        'gestion_vehiculos_vc.aletaDelDer' | translate
                                                                        }}:</label>
                                                                    <div class="col-5">
                                                                        <kendo-dropdownlist [data]="comboCarroceria[19]"
                                                                            [textField]="'PointStateDescription'"
                                                                            [valueField]="'PointState'"
                                                                            [valuePrimitive]="true"
                                                                            [popupSettings]="{ width: 150 }"
                                                                            formControlName="aletaDelDer"
                                                                            (valueChange)="estadoPieza('aletaDelDer',$event)">
                                                                            <ng-template kendoDropDownListItemTemplate
                                                                                let-dataItem>
                                                                                <span class="kendo_list_template">{{
                                                                                    dataItem.PointStateDescription
                                                                                    }}</span>
                                                                            </ng-template>
                                                                        </kendo-dropdownlist>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </form>

                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <!--CITAS -->
                            <kendo-tabstrip-tab [disabled]="!showCitas" [selected]="tab === 7"
                                [title]="'stock_vo.citas' | translate">
                                <ng-template kendoTabContent>
                                    <div [ngClass]=" {
                                                'contenedor_pestana_big':comprobarAltura() ,
                                                'contenedor_pestana_small':!comprobarAltura()
                                                }">
                                        <div class="row">
                                            <div class="col-12">

                                                <kendo-grid class="home-grid" [data]="gridView" [height]="250"
                                                    [pageable]="false" [selectable]="true" [resizable]="true"
                                                    [sort]="false" (edit)="calendarioCitas($event)">
                                                    <kendo-grid-column field="DeliveryDate"
                                                        title="{{ 'gestion_vehiculos_vc.table_th.fechaRecepcion' | translate }}"
                                                        [width]="50" [headerStyle]="headerStyle">
                                                    </kendo-grid-column>
                                                    <kendo-grid-column field="PreviewedReturnDate"
                                                        title="{{ 'gestion_vehiculos_vc.table_th.fechaEntrega' | translate }}"
                                                        [width]="50" [headerStyle]="headerStyle">
                                                    </kendo-grid-column>


                                                    <kendo-grid-column field="AppointmentHeaderID"
                                                        title="{{ 'gestion_vehiculos_vc.table_th.citaNum' | translate }}"
                                                        [width]="20" [headerStyle]="headerStyle">
                                                        <ng-template kendoGridCellTemplate let-dataItem
                                                            let-rowIndex="rowIndex">
                                                            <div>
                                                                <button kendoGridEditCommand type="button"
                                                                    class="btn-steps">
                                                                    <span
                                                                        class="k-icon k-i-calendar color_blue mr-1"></span>
                                                                    {{dataItem.AppointmentHeaderID}}
                                                                </button>
                                                            </div>

                                                        </ng-template>
                                                    </kendo-grid-column>


                                                    <kendo-grid-command-column [width]="20"
                                                        title="{{ 'gestion_vehiculos_vc.table_th.fichaVc' | translate }}">
                                                        <ng-template kendoGridCellTemplate>

                                                            <button (click)="fichas()" type="button"
                                                                class="btn-steps block">
                                                                <span class="k-icon k-i-edit color_blue mr-1"></span>
                                                            </button>

                                                        </ng-template>
                                                    </kendo-grid-command-column>


                                                </kendo-grid>

                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <kendo-tabstrip-tab *ngIf="pais === 'fr'" [disabled]="!stockVO" [selected]="tab === 8"
                                [title]="'stock_vo.carctVeh' | translate">
                                <ng-template kendoTabContent>
                                    <div [ngClass]=" {'contenedor_pestana_big':comprobarAltura() ,
                                                      'contenedor_pestana_small':!comprobarAltura()}">
                                        <div class="col-12">

                                            <form [formGroup]="caractVehic" class="row mt-2">
                                                <div class="col-6">

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.numeroPlazas' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="Seats" type="number" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.carroceria' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="BodyWork" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.colorExterior' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="ExteriorColor" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6">

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.colorInterior' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="InteriorColor" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.potencia' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="FiscalPower" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.velocidad' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="Speed" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>

                            <kendo-tabstrip-tab *ngIf="pais === 'fr'" [disabled]="!stockVO" [selected]="tab === 9"
                                [title]="'stock_vo.AchatVehi' | translate">
                                <ng-template kendoTabContent>
                                    <div [ngClass]="{'contenedor_pestana_big':comprobarAltura() ,
                                                     'contenedor_pestana_small':!comprobarAltura()}">
                                        <div class="col-12">

                                            <form [formGroup]="compraVehic" class="row mt-2">
                                                <div class="col-6">

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.codSociedad' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="VehicleCompanyCode" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.nombreSociedad' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="VehicleCompanyName" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.codSite' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="SiteCode" type="number" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.nombreSite' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="SiteLabel" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-4">{{'labels.codUbicacion' | translate}}:
                                                        </label>
                                                        <div class="col-8">
                                                            <input formControlName="LocationCode" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-6">

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-5">{{'labels.nombreUbicacion' | translate}}:
                                                        </label>
                                                        <div class="col-7">
                                                            <input formControlName="LocationDescription" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-5">{{'labels.codVendedorComprador' | translate}}:
                                                        </label>
                                                        <div class="col-7">
                                                            <input formControlName="SaleBuyerCode" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-5">{{'labels.nombreVendedorComprador' | translate}}:
                                                        </label>
                                                        <div class="col-7">
                                                            <input formControlName="SaleBuyerName" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>

                                                    <div class="col-12 mt-2 row">
                                                        <label class="col-5">{{'labels.nombreClienteProveedor' | translate}}:
                                                        </label>
                                                        <div class="col-7">
                                                            <input formControlName="VOSupplierCustomerName" type="text" class="form-control form-control-sm">
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </ng-template>
                            </kendo-tabstrip-tab>
                        </kendo-tabstrip>
                    </div>

                    <div class="col-12 mt-1 p-0"
                        *ngIf="!gestionTerceros && !gestionOr && !recepcionVehiculo && !recepcionVO && !presupuestosTaller && !isModal">
                        <button type="button" (click)="getAnterior()" class="btn btn-secondary">
                            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
                            {{'labels.volver' | translate}}</button>
                    </div>

                    <div class="col-12 p-0" *ngIf="gestionTerceros" id="cancelarGestForm">
                        <button type="button" (click)="cancelarOut()" class="btn btn-secondary azul float-left">
                            <span class="k-icon k-i-undo"></span>
                            {{'labels.cancelar' | translate}}
                        </button>

                        <button type="button" [disabled]="vehiculoForm.invalid" (click)="addVehiculo()"
                            class="btn btn-secondary verde float-right">
                            {{'labels.anadir_vehiculo' | translate}}
                            <span class="k-icon k-i-plus"></span>
                        </button>

                    </div>

                    <div class="row" *ngIf="recepcionVehiculo || recepcionVO">
                        <div class=" col-2 ">
                            <button type=" button" (click)="cancelarVehiculoRecepcion()"
                                class="btn btn-secondary azul float-left">
                                <span class="k-icon k-i-undo"></span>
                                {{'labels.cancelar' | translate}}
                            </button>
                        </div>
                        <div class="col-6 "></div>

                        <div class="col-4 ">
                            <button type="button" [disabled]="vehiculoForm.invalid" (click)="addVehiculo()"
                                class="btn btn-secondary verde float-right">
                                {{'labels.continuarRecepcion' | translate}}
                                <span class="k-icon k-i-plus"></span>
                            </button>
                        </div>
                    </div>

                    <div class="d-flex align-items-center justify-content-between" *ngIf="presupuestosTaller">
                        <button type=" button" (click)="cancelarVehiculoRecepcion()" class="btn btn-secondary to-left">
                            <i class="fa fa-ban" aria-hidden="true"> </i>
                            {{'labels.cancelar' | translate}}
                        </button>

                        <button type="button" [disabled]="vehiculoForm.invalid" (click)="addVehiculo()"
                            class="btn btn-secondary to-rigth ">
                            {{'labels.continuarRecepcion' | translate}}
                            <i class="fa fa-plus-circle" aria-hidden="true">
                            </i>
                        </button>
                    </div>




                </form>
            </section>
        </div>
    </div>



    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 m-0 p-1"
        *ngIf="!gestionTerceros && !gestionOr && !recepcionVehiculo && !recepcionVO && !presupuestosTaller">
        <div class="contenedor-div border-0" *ngIf="!stockVO">

            <button type="button" (click)="guardarDatos()" [disabled]="validarFormularioVehiculos() || carData.InternalVehicleUse === 'VO' || isModal"
                class="btn btn-secondary btn-block text-left mb-1">
                {{ 'labels.guardar_cambios' | translate }} <i class="fa fa-save float-right"></i>
            </button>
        </div>
        <div class="contenedor-div border-0" *ngIf="stockVO">

            <button *ngIf="!siBaja" type="button" (click)="guardarDatos()" [disabled]="validarFormularioVehiculos() || isModal"
                class="btn btn-secondary btn-block text-left mb-1">
                {{ 'labels.guardar_cambios' | translate }} <i class="fa fa-save float-right"></i>
            </button>

            <button *ngIf="siBaja" type="button" class="btn btn-secondary btn-block text-left mt-0 mb-1 "
                (click)="reactivarVehiculo()" [disabled]="isModal">
                {{ "labels.reactivarV" | translate }}
                <span class="fa fa-save float-right"></span>
            </button>

            <button type="button" class="btn btn-secondary btn-block text-left mt-0 mb-1 " (click)="darBaja()"
                [disabled]="siBaja || isModal">
                {{ "labels.baja" | translate }}
                <span class="k-icon k-i-plus-circle float-right color_white"></span>
            </button>
        </div>


        <information-box *ngIf="informationBox" [textoBox]="textoBoxForm"></information-box>
        <!-- CAja de resultados ??? -->
        <div class="contenedor-div box-search" *ngIf="boxSearch">
            <div appCurrentColor [backgroundColor]="true" class="container-header color_blanco">
                <span>
                    <span class="k-icon k-i-search"></span>
                    {{'labels.resultados' | translate}}
                </span>
            </div>

            <div class="searchResuilt fadeIn">
                <section class="customer-container" *ngIf="!loadingData">

                    <div (click)="clickGetSearchInfoBoxResults(data)" class="m-0 p-1 text-size-small cursor"
                        *ngFor="let data of informationClientSearch; let even = even"
                        [ngClass]="{'color_subbody_header': even}">
                        <span class="block">{{data.CustomerName}}</span>
                        <span class="block">{{data.CustomerCode}} </span>
                        <span class="block">{{data.FiscalCode}}</span>
                    </div>


                </section>

                <div *ngIf="loadingData" class="kendo-loading">
                    <span appCurrentColor class="k-icon k-i-loading small"></span>
                </div>

            </div>

        </div>

    </div>
</div>

<div *ngIf="isLoadingGestion" class="kendo-loading" [style.height.px]="350">
    <span appCurrentColor class="k-icon k-i-loading big"></span>
</div>

<div class="fondo-gris2" *ngIf="showModalESA">
    <app-modal-esa [Vin]="Vin" [Plate]="PlateNumber" [BrandCode]="BrandCode" [Description]="carData['Description']"
        [PlateRegistrationDate]="registrationDate" (modalCloseEsa)="onCloseModalESA($event)"></app-modal-esa>
</div>
